import { TrainIdentifier } from "@vygruppen/vy-train-map";
import {
  isWheelchairPassengerEvent,
  WheelchairPassengerEvent,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/AssistanceEventGridItem/AssistanceType";
import {
  AltTransIncidentTasks,
  AltTransIncidentTrain,
  AltTransTrainId,
  AltTransTrainStation,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { TrainInformation } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/useAssistanceInTimePeriod";
import { mapNotNull } from "shared/utils/objectUtils";

export function getLabelForAltTransStation(station: AltTransTrainStation) {
  return station.reference.jbvId ?? station.name ?? "MANGLER";
}

export function isSameTrainId(first: TrainIdentifier, second: AltTransTrainId) {
  return (
    first.countryCode === second.countryCode &&
    first.identifier === second.id &&
    first.nominalDate === second.nominalDate
  );
}

export function groupAssistanceByEntryPoint(
  assistanceInformation: Array<TrainInformation>,
  tasksResponse: AltTransIncidentTasks,
) {
  // TODO: Fix the TrainInformation type to include all train information variants.
  //       This means we will also need to decouple it from the modals, to prevent
  //       the creation of unsupported events
  const assistanceEvents = assistanceInformation.filter(
    isWheelchairPassengerEvent,
  ) as unknown as WheelchairPassengerEvent[];

  const getAssistanceForTrain = (train: AltTransIncidentTrain) =>
    assistanceEvents.find((info) =>
      isSameTrainId(info.trainIdentifier, train.id),
    );

  const informationInside = mapNotNull(
    tasksResponse.trainsAtIncident,
    getAssistanceForTrain,
  );

  const stableOrderInformationOutside = tasksResponse.trainsOutsideIncident.map(
    (entryPoint) => mapNotNull(entryPoint.trains, getAssistanceForTrain),
  );

  return { informationInside, stableOrderInformationOutside };
}

export const ACTIONABLE_TRAIN_SECTION_FLEX_BASE = "706px";
export const ACTIONABLE_TRAIN_SECTION_COLLAPSED_WIDTH = "220px";

export const ACTIONABLE_TRAINS_CSS_CONTAINER_NAME = "actionableTrainsWrapper";
export const ACTIONABLE_TRAIN_SECTION_CSS_CONTAINER_NAME =
  "actionableTrainSection";

export function aggregateTrainCount(trains: AltTransIncidentTrain[]): number {
  return (
    trains.reduce(
      (subtotal, train) =>
        subtotal + (train.passengerCount.incidentStretchPassengerCount ?? 0),
      0,
    ) ?? 0
  );
}
